<template>
  <div class="start flex flex-wrap -mx-2">
    <div class="w-full" v-html="content"></div>
  </div>
</template>

<script>
import endpoints from '../../endpoints'
import axios from 'axios'

export default {
  name: 'Agb',

  data () {
    return {
      content: '',
    }
  },

  created () {
    this.load()
  },

  methods: {
    load () {
      axios.post(endpoints.agb + '/' + (window.type !== 'foodi' && window.hostId > 0 ? window.hostId : ''), {})
        .then(response => {
          this.content = response.data.content
        })
    },
  }
}

</script>

<style lang="scss">
h2,
h3 {
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/views/agb/index.vue